exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg{height:150px;width:220px}.fit-img{width:62%;height:90%}.sidebar-content{height:94vh;overflow:scroll}.group-title{font-size:14px;text-transform:uppercase;font-weight:700;opacity:.8;padding:6px 8px;margin-top:8px;letter-spacing:1.1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e6ef348","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sidebar.vue
// module id = 411
// module chunks = 0